import { PageId } from 'constants/pages'
import { TPageMapValue } from 'models/common.model'
import { lazy } from 'react'
import { PageIdWoofzNdd75 } from './pages'

type TIdToPageMapWoofzLove = Record<PageIdWoofzNdd75, TPageMapValue>

export const ID_TO_PAGE_MAP_WOOFZ_NDD_75: TIdToPageMapWoofzLove = {
  [PageId.SUBSCRIPTIONS_NDD_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_75/pages/subscriptions/SubscriptionNdd75'
      ).then((m) => ({
        default: m.SubscriptionsNdd75,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_75/pages/subscriptions/SubscriptionNdd75'
      ),
  },
  [PageId.CHAT_UPSELL_NDD_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_75/pages/upsell/ChatUpsellNewFlow'
      ).then((m) => ({
        default: m.ChatUpsellNewFlow,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_75/pages/upsell/ChatUpsellNewFlow'
      ),
  },
  [PageId.UPSELL_NDD_75]: {
    Component: lazy(() =>
      import('nove8/cohorts/woofz_ndd/woofz_ndd_75/pages/upsell/Upsell').then(
        (m) => ({
          default: m.Upsell,
        }),
      ),
    ),
    preload: () =>
      import('nove8/cohorts/woofz_ndd/woofz_ndd_75/pages/upsell/Upsell'),
  },
  [PageIdWoofzNdd75.DOWNLOAD_NDD_75]: {
    Component: lazy(() =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_75/pages/download-app/DownloadApp'
      ).then((m) => ({
        default: m.DownloadApp,
      })),
    ),
    preload: () =>
      import(
        'nove8/cohorts/woofz_ndd/woofz_ndd_75/pages/download-app/DownloadApp'
      ),
  },
  [PageIdWoofzNdd75.ACCOUNT_NOVE8]: {
    Component: lazy(() =>
      import('nove8/modules/account/AccountNove8').then((m) => ({
        default: m.AccountNove8,
      })),
    ),
    preload: () => import('nove8/modules/account/AccountNove8'),
  },
}
